<script>
    const uuidv1 = require('uuid/v1');
    import OpportunityCard from './OpportunityCard'
    import DeleteIcon from 'vue-material-design-icons/Delete.vue';

    export default {
        components: {
            OpportunityCard,
            DeleteIcon
        },      
        props: ['company', 'editable'],
        async mounted () {   
          if ( this.company.businessOpportunities ) {
            this.oppHash = this.snapshotToHash( this.company.businessOpportunities )
          }
          this.oppTypeMap = await this.$store.getters.opportunityTypes 
        },
        data() {
            return {
                editing: false,
                originalOppHash: {},
                oppHash: {},
                oppTypeMap: [],
                renderOpportunities: true           
            }
        },
        methods: {   
          snapshotToHash(snapshot) {
            var retval = {};

            Object.keys(snapshot).forEach( function(k) {
                retval[k] = snapshot[k]
            });

            return retval;
          },
          dismiss() {
            this.oppHash = this.originalOppHash
            this.editing = false;
          },
          openModal() {
            console.log("openModal basic")
            if ( this.company.businessOpportunities ) {
              this.oppHash = this.snapshotToHash( this.company.businessOpportunities )
            }
            this.originalOppHash = this.oppHash
            //this._company = this.company
            this.editing = true
          },
          removeOpportunity( key ) {
            if ( confirm("Delete this class?") ) {
              delete this.oppHash[ key ]
              this.refreshModal()
            }
          },
          refreshModal(){
            this.renderOpportunities = false
            this.$nextTick(() => {
              this.renderOpportunities = true
            });  
          },
          addOpportunity() {
            console.log("opportunity knocks!")
            // generate a key
            //var newKey = Math.floor(Date.now() / 1000).toString()
            var newKey = uuidv1()
            this.oppHash[ newKey ] = {
              contactName: "",
              contactEmail: "",
              contactPhone: "",
              description: "",
              title: "",
              type: ""
            }
            this.refreshModal()
            
          },
          save() {
            // this.company.description = this.desc
            this.company.businessOpportunities = this.oppHash
            console.log("emitting save")
            this.$emit('save')
            this.editing=false
          }  
        }     
    }
</script>



<template lang="pug">

.foo 
  p 
  #opps.z-depth-1
    .row.edit-div(v-if="editable")
      .col.s12.right-align
        img.edit-icon.modal-trigger(data-target='industry-opportunities-modal' src='@/assets/svg/bluepencil.svg' @click="openModal")
    .opps-container
      .row
          h6  Current Opportunities
      //Edit opps div if company has no opportunities
      #no-opps.row.edit-div(v-if="!company.businessOpportunities || company.businessOpportunities.length == 0")
        img.edit-icon.modal-trigger(data-target='industry-opportunities-modal' src='@/assets/svg/blueplussign.svg' @click="openModal")
        span
          | Add an opportunity. Let educators know what opportunities you have for their students!

      #opp-list(v-else)
        .row.opp( v-for="(opp, key) in company.businessOpportunities" )
          opportunity-card( :opp="opp", :oppTypeMap="oppTypeMap" )    


  #industry-opportunities-modal(v-if="editing")
    .modal-overlay2(@click="dismiss")
      .modal-content( @click.stop="" v-if="renderOpportunities")
        .row.modal-header
          .col.s12.header-lgn
            h5.center-align Current Opportunities
            hr
        .scrollable-content
          .opportunity-template( v-for="(opp, key) in oppHash")
            .template-row
              .row 
                .col.s6.offset-s1.input-field
                  p.form-label Opportunity Title
                  input.opportunity-title.input-div.opp-title(type='text' v-model="opp.title")
                .col.s4.right-align
                  delete-icon.delete-opportunity(@click="removeOpportunity(key)")
                  //- i#opp-clear.opp-icon.material-icons(@click="removeOpportunity(key)" href="#").menu clear
                  
              .row
                .col.s10.offset-s1.input-field
                  p.form-label Opportunity Type
                  .row.radio-grp
                    .opptyperow(v-for="(opptype, index) in oppTypeMap")
                      input.opp-type.student(
                        :name='"opp-group" + key' 
                        type='radio' 
                        v-model="opp.type_code"
                        :value="index"
                        )
                      label.opp-type-label(for='student') {{opptype}} 
               

              .row
                .col.s10.offset-s1.input-field
                  p.form-label Opportunity Description
                  textarea.materialize-textarea#opp-desc.opp-desc(v-model="opp.description")
              .row
                .col.s10.offset-s1.input-field
                  //label(for='contact-name') Name of Contact Person
                  p.form-label Name of Contact Person
                  input.contact-name.input-div.opp-contact(type='text' v-model="opp.contactName")
              .row
                .col.s10.offset-s1.input-field
                  //label(for='contact-email') Email
                  p.form-label Email
                  input.contact-email.input-div.opp-email(type='text' v-model="opp.contactEmail")
              .row
                .col.s10.offset-s1.input-field
                  //label(for='contact-phone') Phone
                  p.form-label Phone
                  input.contact-phone.input-div.opp-phone(type='text' v-model="opp.contactPhone")
              hr.margin-top-hr

        .modal-footer( @click.stop="" )
          .row.addcontainer
            .col.s12.m8.offset-m4
              a.addbtn.btn-floating.btn-small.waves-effect.waves-light#add-opportunity(@click="addOpportunity()") +
              .addtext Add another opportunity
          .row
            .col.s12.close-btn-div
              button.close-btn.modal-close#save-opportunities(type='button' @click="save") SAVE
            .col.s12.close-btn-div
              button.close-btn.modal-close(type='button' @click="dismiss") CANCEL



</template>



<style lang="sass" scoped>

// .modal-header
//   height: 10%

// .scrollable-content
//   height: 80%
//   overflow: hide

// .modal-footer 
//   height: auto

.addcontainer
  text-align: center
  col
    margin: 0 auto

a.addbtn
  float: left

.addtext 
  float: left
  top: 5px
  left: 5px
  position: relative

.opp-desc
  min-height: 100px
  border: 2px solid black;

.delete-opportunity
  font-size: 2em
  cursor: pointer

.delete-opportunity:hover
  color: red  

#add-opportunity
  font-size: 2em;
  line-height: 1em;

#opps 
  padding: .5em;

.opps-container, .intro-container 
    padding: 0 1em 0 1em;

#company-img
  padding: 0;


#name
  margin-top: 0;


#search-hdr h5 
  padding-top: 1em;


#search-hdr p 
  padding-bottom: 1em;


.input-div.opp-title 
  color: #000 !important;
  font-weight: normal !important;

.opp-type-label
    left: 20px !important;
    position: relative;
    top: -5px;

.opptyperow
   float: left
   padding-right: 50px

.opp-title 
  color: #1589FF;
  font-weight: bold;

input[type="radio"]
   opacity: 1 !important
   pointer-events: all !important


.opp-details 
  font-size: 14px; 

#no-info span, #no-opps span 
  font-size: 12px;
  color: #bbbbbb;
</style>